module.exports = __webpack_public_path__ + "img/stp_scan_orange.92a2394c.svg";